export default __webpack_public_path__ + "static/media/Ballroll_00185.1856ce2a.png";